import LTable2 from './src/main'

/* istanbul ignore next */
LTable2.install = function(Vue) {
  Vue.component(LTable2.name, LTable2)
}

export default LTable2
